module.exports = __webpack_public_path__ + "img/65728.7480463d.png";